import { ImageBaseSize } from '../image-base';

export const getBorderRadiusBySize = (size: ImageBaseSize): number => {
  if (size <= 28) {
    return 4;
  }

  if (size <= 48) {
    return 8;
  }

  return 12;
};
